export default __webpack_public_path__ + "cdb5f1e54afbddba7545df846f2b6871.png";